import { useTranslation } from 'react-i18next';
import { Stack } from 'shell/components';
import AdminOverrideNotice, { ADMIN_OVERRIDE_STATE } from './AdminOverrideNotice';
import SettingsSection from './SettingsSection';
import SettingToggle from './SettingToggle';

const PreferenceSection = ({
    id,
    title,
    description,
    toggleLabel,
    toggleDescription,
    enabled,
    adminOverrideState,
    disabled = false,
    onToggle,
    children,
}) => {
    const { t } = useTranslation();
    const isOverridden = adminOverrideState === ADMIN_OVERRIDE_STATE.OVERRIDDEN;
    const displayedEnabled = isOverridden ? false : enabled;
    const showRelatedControls = enabled && !isOverridden;
    const disabledTooltip = isOverridden
        ? {
              component: t(
                  'settings.admin-override.disabled-tooltip',
                  'Disabled by your institution. Request access or contact IT.'
              ),
          }
        : undefined;

    return (
        <SettingsSection id={id} title={title} description={description}>
            <Stack spacing={6}>
                <SettingToggle
                    label={toggleLabel}
                    description={toggleDescription}
                    checked={displayedEnabled}
                    disabled={disabled || isOverridden}
                    tooltip={disabledTooltip}
                    onChange={onToggle}
                    labelTextProps={{ variant: 'p2' }}
                    descriptionTextProps={{ color: 'light', variant: 'p2' }}
                />
                {isOverridden && <AdminOverrideNotice state={ADMIN_OVERRIDE_STATE.OVERRIDDEN} />}
                {showRelatedControls && (
                    <>
                        <AdminOverrideNotice state={ADMIN_OVERRIDE_STATE.MAY_OVERRIDE} />
                        {children}
                    </>
                )}
            </Stack>
        </SettingsSection>
    );
};

export default PreferenceSection;
